import { z } from 'zod';
import { TypedApiClient } from '../index';
import { schemas } from '../../generated/api-client';
import { apiPath } from '../path';

// ====== Import schemas from generated ======
const {
  PaymentMethodFirestoreResponse,
  CreatePaymentMethodDto,
  UpdatePaymentMethodDto,
  DeletePaymentMethodResponseDto,
} = schemas;

// ====== Re-export schemas for external use ======
export const PaymentMethodResponseSchema = PaymentMethodFirestoreResponse;
export const CreatePaymentMethodSchema = CreatePaymentMethodDto;
export const UpdatePaymentMethodSchema = UpdatePaymentMethodDto;
export const DeleteResponseSchema = DeletePaymentMethodResponseDto;

// Type exports
export type PaymentMethodResponse = z.infer<typeof PaymentMethodFirestoreResponse>;
export type CreatePaymentMethod = z.infer<typeof CreatePaymentMethodDto>;
export type UpdatePaymentMethod = z.infer<typeof UpdatePaymentMethodDto>;

// API factory function
export function createPaymentMethodsApi(client: TypedApiClient) {
  return {
    getPaymentMethods: (): Promise<PaymentMethodResponse[]> => {
      return client.get('/payment-methods', {
        responseSchema: z.array(PaymentMethodResponseSchema),
      });
    },

    createPaymentMethod: (data: CreatePaymentMethod): Promise<PaymentMethodResponse> => {
      CreatePaymentMethodSchema.parse(data);
      return client.post('/payment-methods', {
        data,
        responseSchema: PaymentMethodResponseSchema,
      });
    },

    updatePaymentMethod: (id: string, data: UpdatePaymentMethod): Promise<PaymentMethodResponse> => {
      return client.patch(apiPath`/payment-methods/${id}`, {
        data,
        responseSchema: PaymentMethodResponseSchema,
      });
    },

    deletePaymentMethod: (id: string): Promise<z.infer<typeof DeleteResponseSchema>> => {
      return client.delete(apiPath`/payment-methods/${id}`, {
        responseSchema: DeleteResponseSchema,
      });
    },
  };
}
